var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more",class:_vm.divClass,style:(_vm.setColor),on:{"click":_vm.onclick}},[(_vm.svgSrc)?_c('img',{class:_vm.imgClass,attrs:{"src":require('../assets/svg/' + _vm.svgSrc)}}):_vm._e(),_c('span',{staticClass:"title",class:_vm.spanClass},[_vm._v(_vm._s(_vm.to))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }